import { NgModule } from '@angular/core';

import { SupportRoutesModule } from './support.routes';
import { SupportComponent } from './support.component';
import { BaseModule } from '../shared/base.module';
import { VideosModule } from './video/videos.module';
import { RouterModule } from '@angular/router';
import { VideosModalModule } from './video/modals/videos-modal.module';
import { PDFsModule } from './pdf/pdf.module';
import { PdfModalModule } from './pdf/modals/pdf-modal.module';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { InformationsModule } from './informations/informations.module';
import { DialogPreviewComponent } from './preview/dialog-preview.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NoRightClickDirective } from '../shared/directives/no-right-click.directive';
import { DirectiveModule } from '../shared/directives/directive.module';
import { BreadcrumbModule } from '../shared/breadcrumb/breadcrumb.module';
import {ReleaseNoteModule} from "./release-note/release-note.module";
import {ReleaseNoteModalModule} from "./release-note/modals/release-note-modal.module";

@NgModule({
    imports: [
        BaseModule,
        RouterModule,
        SupportRoutesModule,
        VideosModule,
        VideosModalModule,
        PDFsModule,
        ReleaseNoteModule,
        TabsModule.forRoot(),
        PdfModalModule,
        ReleaseNoteModalModule,
        InformationsModule,
        MatDialogModule,
        DirectiveModule,
        BreadcrumbModule
    ],
    declarations: [
        SupportComponent,
        DialogPreviewComponent,
    ],
    entryComponents: [
        DialogPreviewComponent
    ],
})
export class SupportModule { }
